// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ec2df26c","732":"4682b76c","977":"939ca5d4"}[chunkId] + ".chunk.js";
};